import { Cancel as CancelIcon, Search as SearchIcon } from '@mui/icons-material'
import { InputAdornment, TextField } from '@mui/material'
import type { SxProps } from '@mui/material/styles'
import { QuickFilter, QuickFilterClear, QuickFilterControl } from '@mui/x-data-grid'

import { SEARCH_FIELD_WIDTH } from '@/constants/layout'

type GridSearchOutlinedProps = {
  sx?: SxProps
  label: string
  placeholder?: string
}

const SEARCH_DEBOUNCE_TIME_MS = 500

function GridSearchOutlined({ sx, label, placeholder }: Readonly<GridSearchOutlinedProps>) {
  return (
    <QuickFilter defaultExpanded debounceMs={SEARCH_DEBOUNCE_TIME_MS}>
      <QuickFilterControl
        render={({ ref, ...controlProps }, state) => {
          return (
            <TextField
              {...controlProps}
              aria-label={label}
              inputRef={ref}
              label={label}
              placeholder={placeholder}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: state.value ? (
                    <InputAdornment position="end">
                      <QuickFilterClear
                        aria-label="Clear search"
                        edge="end"
                        material={{ sx: { marginRight: -0.75 } }}
                        size="small"
                      >
                        <CancelIcon fontSize="small" />
                      </QuickFilterClear>
                    </InputAdornment>
                  ) : null,
                  ...controlProps.slotProps?.input,
                },
                ...controlProps.slotProps,
              }}
              sx={{
                width: SEARCH_FIELD_WIDTH,
                ...sx,
              }}
            />
          )
        }}
      />
    </QuickFilter>
  )
}

export default GridSearchOutlined
